/* import __COLOCATED_TEMPLATE__ from './template-tile.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();